const menuItemsWithChildren = document.querySelectorAll( '.desktop-header-main-menu > li.menu-item-has-children' )
const allMenuItems = document.querySelectorAll( '.desktop-header-main-menu > li' )

let allowHoverMenus = false

const init = function() {

    // Enable hover after a delay to prevent immediate hover on page load
    setTimeout( () => {
        allowHoverMenus = true;
    }, 500 );
    
    // Setup submenus
    if ( menuItemsWithChildren ) {

        menuItemsWithChildren.forEach( item => {

            let menuTimer = null
            const button = item.querySelector( 'button' )
            const submenu = item.querySelector( 'ul' )

             // Add important ARIA attributes if not already present
             if ( button && submenu ) {

                // Ensure proper IDs for ARIA references
                if (!submenu.id) submenu.id = `submenu-${Math.random().toString(36).substring(2, 9)}`

                button.setAttribute( 'aria-controls', submenu.id )
                button.setAttribute( 'aria-expanded', 'false' )
                submenu.setAttribute( 'aria-hidden', 'true' )
            }

            // Mouse hover to display submenu
            item.addEventListener( 'mouseenter', () => {
                if ( allowHoverMenus ) showDesktopSubmenu( item, menuTimer )
            } )

            // Click submenu button to toggle submenu
            button.addEventListener( 'click', ( event ) => {
                event.preventDefault()

                // Check if submenu is already visible
                if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
                    hideDesktopSubmenu( item )
                } else {
                    showDesktopSubmenu( item, menuTimer )
                }

            })

            // Handle keyboard navigation
            button.addEventListener( 'keydown', ( event ) => {
                if ( event.key === 'Enter' || event.key === ' ' ) {
                    event.preventDefault()

                    // Toggle submenu visibility
                    if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
                        hideDesktopSubmenu( item )
                    } else {
                        showDesktopSubmenu( item, menuTimer )
                    }

                } else if ( event.key === 'ArrowDown' || event.key === 'Down' ) {
                    event.preventDefault()

                    // Always ensure menu is open when navigating down
                    showDesktopSubmenu( item, menuTimer )

                    // Move focus to first submenu item
                    const firstSubmenuLink = item.querySelector( 'ul.sub-menu > li > a' )

                    if ( firstSubmenuLink ) firstSubmenuLink.focus()

                }
            })

            // When the mouse leaves an item with children, as long
            // as the new hover target is not an ancestor, hide the submenu
            // with a slight delay for improved accessibility
            item.addEventListener( 'mouseout', event => {

                if ( item.contains( event.relatedTarget ) ) return

                menuTimer = setTimeout( () => {
                    hideDesktopSubmenu( item )
                }, 500 )

            } )

            // Add touch support for mobile devices
            item.addEventListener( 'touchend', event => {

                // Get the button element
                const button = item.querySelector( 'button' );
            
                // If tapping on the item but not the button
                if (event.target !== button) {

                    // Only prevent default and handle manually if submenu is not open
                    if ( !item.classList.contains( 'submenu-active' ) ) {

                        event.preventDefault()
                        hideAllSubmenusOnDesktop()
                        showDesktopSubmenu(item, menuTimer)
                    }

                }

                // Let the click event fire normally for the button
            }, { passive: false });

        } )

    }

    // Reset menus when focusing new parent
    if ( allMenuItems ) {

        allMenuItems.forEach( item => {

            let menuTimer = null
            const link = item.querySelector( 'a' )

            link.addEventListener( 'focus', () => {
                clearTimeout( menuTimer )
                hideAllSubmenusOnDesktop()
            } )

        } )

    }

    // On "esc" close menus
    document.addEventListener( 'keydown', ( event ) => {        
        if ( event.key === 'Escape' ) hideAllSubmenusOnDesktop()
    } )

}


const showDesktopSubmenu = function( item, timer ) {

    clearTimeout( timer )
    hideAllSubmenusOnDesktop()

    const button = item.querySelector( 'button' )
    const submenu = item.querySelector( 'ul' )

    button.setAttribute( 'aria-expanded', 'true' )
    submenu.setAttribute( 'aria-hidden', 'false' )
    item.classList.add( 'submenu-active' )

}


const hideAllSubmenusOnDesktop = function() {

    if ( menuItemsWithChildren ) {
        menuItemsWithChildren.forEach( item => { hideDesktopSubmenu( item ) } )
    }

}


const hideDesktopSubmenu = function(item) {

    const button = item.querySelector('button')
    const submenu = item.querySelector('ul')

    button.setAttribute( 'aria-expanded', 'false' )
    submenu.setAttribute( 'aria-hidden', 'true' )
    item.classList.remove( 'submenu-active' )

}


const api = {
    init: init
}


export default api;
